import React from 'react';
import { ImageIcon } from 'lucide-react';
type MockupSlotProps = {
  /** URL del mockup real. Vacío = placeholder identificado. */
  src: string;
  alt: string;
  slot: string;
  label: string;
  tone?: 'pink' | 'blue';
  aspect?: string;
};
const tones = {
  pink: {
    border: 'border-[#F5B4C9]',
    chip: 'bg-[#FDE3EC] text-[#E74D7A]'
  },
  blue: {
    border: 'border-[#93D1CE]',
    chip: 'bg-[#DDF2F1] text-[#15ADA8]'
  }
};
export function MockupSlot({
  src,
  alt,
  slot,
  label,
  tone = 'pink',
  aspect = 'aspect-[4/3]'
}: MockupSlotProps) {
  if (src) {
    return <img src={src} alt={alt} data-slot={slot} loading="lazy" className={`${aspect} w-full rounded-2xl object-cover`} data-id="element-257" data-mp="s8fjluue4sh3" />;
  }
  const t = tones[tone];
  return <div data-slot={slot} role="img" aria-label={`Espacio reservado: ${label}`} className={`${aspect} flex w-full flex-col items-center justify-center gap-2.5 rounded-2xl border-2 border-dashed bg-[#FDF9F3] px-6 text-center ${t.border}`} data-id="element-258" data-mp="iim8sw22ohdw">
      <span className={`flex h-11 w-11 items-center justify-center rounded-2xl ${t.chip}`} aria-hidden="true" data-id="element-259" data-mp="1g3k5iwtq5g0l">
        <ImageIcon className="h-5 w-5" strokeWidth={1.5} data-id="element-260" data-mp="1l2dimo53n508" />
      </span>
      <span className="text-[12px] font-bold uppercase tracking-[0.06em] text-[#8B6B55]" data-id="element-261" data-mp="1l4rayp8ea343">Mockup real próximamente</span>
      <span className="text-[13px] leading-snug text-body" data-id="element-262" data-mp="1bctzdhdh594u">{label}</span>
    </div>;
}